import React, { useEffect, useState, useContext, useCallback } from "react";
import { Icon, IconButton, Typography } from "@material-ui/core";
import { isNil, orderBy } from "lodash";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import * as dashboardAPI from "../../api";
import { useStyles, commonIconStyles } from "./MicroserviceStatusStyles";
import {
  API_FORM_STATUS,
  HTTP_STATUS_NOT_FOUND,
  HTTP_STATUS_UNAUTHORIZED,
  SERVER_HOST,
  TOAST_CONTAINER_LAYOUT,
} from "../../../../util/Constants";
import CustomBodyToast from "../../../../components/toast/CustomBodyToast";
import { AuthContext } from "../../../../core/providers/AuthContext";
import useWindowDimensions from "../../../../core/hooks/useWindowDimensions";
import useIsMounted from "react-is-mounted-hook";
import MicrosTable from "./MicrosTable2";

const GET_STATUS_METHOD = "/get";

export default function MicroseriveStatus() {
  const {
    auth: { token },
    logout,
  } = useContext(AuthContext);
  const { t } = useTranslation();
  const [fetching, setFetching] = useState(false);
  const [statusList, setStatusList] = useState(null);
  const wd = useWindowDimensions();
  const classes = useStyles({ wd });
  const isMounted = useIsMounted();
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    if (token && showTable) {
      callServerToGetMicrosStatus(token);
    }

    return () => null;
    //eslint-disable-next-line
  }, [token, showTable]);

  async function callServerToGetMicrosStatus(token) {
    if (!fetching && isMounted()) setFetching(true);
    const url = SERVER_HOST() + API_FORM_STATUS + GET_STATUS_METHOD;

    const response = await dashboardAPI.getStatusApps(token, url);
    await analyzeResponse(response);
    if (isMounted()) setFetching(false);
  }

  async function analyzeResponse(response) {
    let toastContent = null;
    if (!isNil(response)) {
      const { ok, errorMsg: msg, dataResponse, status } = response;
      if (status === HTTP_STATUS_UNAUTHORIZED) {
        logout(true);
      } else if (status === HTTP_STATUS_NOT_FOUND) {
        toastContent = (
          <CustomBodyToast
            title={t("ERROR_RESOURCE_NOT_FOUND_TEXT")}
            msg={null}
          />
        );
      } else {
        if (ok) {
          if (dataResponse) {
            const { application } = dataResponse;
            if (isMounted()) setStatusList(application);
          }
        } else {
          toastContent = <CustomBodyToast title={msg} msg={null} />;
        }
      }
    } else {
      toastContent = (
        <CustomBodyToast title={t("FORM_ERROR_ACTION")} msg={null} />
      );
    }

    //If something to notify, then throw toast
    if (!isNil(toastContent)) {
      toast.error(toastContent, {
        containerId: TOAST_CONTAINER_LAYOUT,
        position: "top-right",
      });
    }
    return response;
  }

  const handleRefresh = useCallback(() => {
    callServerToGetMicrosStatus(token);
    //eslint-disable-next-line
  }, [token]);

  function toggleTable() {
    setShowTable((prev) => !prev);
  }

  return (
    <div className={classes.infoContainer}>
      <IconButton onClick={toggleTable} className={classes.showTableBtn}>
        <Icon
          className={showTable ? "fas fa-eye-slash" : "fas fa-signal"}
          style={{ ...commonIconStyles, color: "white" }}
        />
        <Typography variant="h6" className={classes.showTableTypo}>
          {showTable ? "Hide Micros Status" : "Show Micros Status"}
        </Typography>
      </IconButton>
      {showTable && (
        <MicrosTable
          statusList={orderBy(statusList, "name")}
          fetching={fetching}
          handleRefresh={handleRefresh}
        />
      )}
    </div>
  );
}
